import Header from './Header';
import { Box } from '@mui/material';
import { Notifications } from './Notifications';
import { SideMenu } from './SideMenu';
import { useSelector } from 'react-redux';
import { WelcomeDialog } from './WelcomeDialog';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';
import { RightMenu } from './RightMenu';

// The content column is the page's scroll container; sticky elements
// (like the item sharing bar) attach to it.
export const APP_SCROLL_CONTAINER_ID = 'app-scroll-container';

const Layout = ({ children }) => {

  const location = useLocation();
  const user = useSelector(state => state.login.user);
  const showWelcomeDialog = window.localStorage.getItem('welcome-dialog') !== 'true';

  const hideFooter = () => {
    return !user ||
      location.pathname.startsWith('/browse') ||
      location.pathname.startsWith('/create-item') ||
      location.pathname.startsWith('/admin') ||
      // Item pages have their own sharing bar; the share page is the destination.
      location.pathname.startsWith('/items/') ||
      location.pathname.startsWith('/share-experience');
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', backgroundColor: 'appShell.background', height: '100dvh' }}>
      <Box sx={{ flexShrink: 0 }}>
        <Header />
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'auto minmax(0, 1fr) auto' }, flex: 1, minHeight: 0 }}>
        <Box component="nav" aria-label="Main" sx={{ width: { sm: '80px', md: '200px' }, height: '100%', overflowY: 'auto', display: { xs: 'none', sm: 'block' } }}>
          <SideMenu />
        </Box>
        <Box
          id={APP_SCROLL_CONTAINER_ID}
          component="main"
          sx={{ minWidth: 0, height: '100%', overflowY: 'auto', backgroundColor: 'background.default', color: 'text.primary' }}
        >
          <Box sx={{ maxWidth: '880px', mx: 'auto', px: { xs: 2, sm: 3 }, pt: { xs: 2, sm: 3 }, pb: 3 }}>
            {children}
          </Box>
        </Box>
        <Box component="aside" sx={{ width: { sm: '80px', md: '200px' }, height: '100%', overflowY: 'auto', display: { xs: 'none', sm: 'block' } }}>
            <RightMenu />
        </Box>
      </Box>
      {hideFooter() ? null :  <Footer />}
      <WelcomeDialog show={showWelcomeDialog} />
      <Notifications />
    </Box>
  );
};

export default Layout;
